/**
 * MOCK DATA - Materials
 * ======================
 * Temporary mock data for frontend development.
 * Will be replaced by real API calls to Supabase.
 * 
 * DO NOT connect to MongoDB.
 * DO NOT invent new fields.
 */

export const MOCK_MATERIALS = [
  {
    id: "mat_bianco_carrara",
    name: "Bianco Carrara",
    stone_type: "Marble",
    color: "White",
    color_hex: "#E8E8E8",
    tone: "light-neutral",
    description: "The iconic Italian marble, known for its soft white background and delicate grey veining. A timeless choice for luxury interiors.",
    main_image_url: "https://images.unsplash.com/photo-1694378061101-bf38a2fcc596?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1694378061101-bf38a2fcc596?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed", "Brushed", "Bush-Hammered", "Sanded"],
    applications: ["Countertop", "Wall", "Floor", "Bathroom"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: true
  },
  {
    id: "mat_nero_marquina",
    name: "Nero Marquina",
    stone_type: "Marble",
    color: "Black",
    color_hex: "#1A1A1A",
    tone: "dark-dramatic",
    description: "A dramatic black marble from Spain with distinctive white veining. Perfect for bold, sophisticated statements.",
    main_image_url: "https://images.pexels.com/photos/11285487/pexels-photo-11285487.png?auto=compress&cs=tinysrgb&w=800",
    images: [
      "https://images.pexels.com/photos/11285487/pexels-photo-11285487.png?auto=compress&cs=tinysrgb&w=1200"
    ],
    finishes: ["Polished", "Honed"],
    applications: ["Countertop", "Wall", "Floor"],
    origin: "Spain",
    producer: "Margraf",
    is_featured: true
  },
  {
    id: "mat_calacatta_oro",
    name: "Calacatta Oro",
    stone_type: "Marble",
    color: "White",
    color_hex: "#F5F5F0",
    tone: "textured-veined",
    description: "The crown jewel of Italian marbles. Warm white background with golden and grey veining. Extremely rare and precious.",
    main_image_url: "https://images.unsplash.com/photo-1690049089775-b915262c89d0?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1690049089775-b915262c89d0?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed", "Brushed"],
    applications: ["Countertop", "Wall", "Bathroom"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: true
  },
  {
    id: "mat_emperador_dark",
    name: "Emperador Dark",
    stone_type: "Marble",
    color: "Brown",
    color_hex: "#4A3728",
    tone: "warm-earth",
    description: "A rich dark brown Spanish marble with lighter veining. Adds warmth and elegance to any space.",
    main_image_url: "https://images.pexels.com/photos/4709033/pexels-photo-4709033.jpeg?auto=compress&cs=tinysrgb&w=800",
    images: [
      "https://images.pexels.com/photos/4709033/pexels-photo-4709033.jpeg?auto=compress&cs=tinysrgb&w=1200"
    ],
    finishes: ["Polished", "Honed"],
    applications: ["Countertop", "Wall", "Floor"],
    origin: "Spain",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_verde_alpi",
    name: "Verde Alpi",
    stone_type: "Marble",
    color: "Green",
    color_hex: "#2D4A3E",
    tone: "green-organic",
    description: "A striking green Italian marble with white veining. Brings nature's beauty into sophisticated interiors.",
    main_image_url: "https://images.unsplash.com/photo-1653939614751-aab4b19b10fd?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1653939614751-aab4b19b10fd?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed", "Brushed"],
    applications: ["Countertop", "Wall"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_rosa_portogallo",
    name: "Rosa Portogallo",
    stone_type: "Marble",
    color: "Pink",
    color_hex: "#D4A5A5",
    tone: "warm-earth",
    description: "A delicate pink Portuguese marble with subtle veining. Perfect for elegant, feminine spaces.",
    main_image_url: "https://images.pexels.com/photos/4709486/pexels-photo-4709486.jpeg?auto=compress&cs=tinysrgb&w=800",
    images: [
      "https://images.pexels.com/photos/4709486/pexels-photo-4709486.jpeg?auto=compress&cs=tinysrgb&w=1200"
    ],
    finishes: ["Polished", "Honed"],
    applications: ["Wall", "Bathroom"],
    origin: "Portugal",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_azul_bahia",
    name: "Azul Bahia",
    stone_type: "Granite",
    color: "Blue",
    color_hex: "#1E3A5F",
    tone: "blue-deep",
    description: "A rare and exotic blue granite from Brazil. Stunning crystalline structure with deep blue tones.",
    main_image_url: "https://images.unsplash.com/photo-1760784213120-04b0f83317a9?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1760784213120-04b0f83317a9?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed"],
    applications: ["Countertop", "Wall"],
    origin: "Brazil",
    producer: "Margraf",
    is_featured: true
  },
  {
    id: "mat_giallo_siena",
    name: "Giallo Siena",
    stone_type: "Marble",
    color: "Yellow",
    color_hex: "#D4A017",
    tone: "warm-earth",
    description: "A warm golden yellow Italian marble. Brings sunshine and warmth to any interior.",
    main_image_url: "https://images.pexels.com/photos/4709524/pexels-photo-4709524.jpeg?auto=compress&cs=tinysrgb&w=800",
    images: [
      "https://images.pexels.com/photos/4709524/pexels-photo-4709524.jpeg?auto=compress&cs=tinysrgb&w=1200"
    ],
    finishes: ["Polished", "Honed", "Brushed"],
    applications: ["Wall", "Floor"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_grigio_carnico",
    name: "Grigio Carnico",
    stone_type: "Marble",
    color: "Grey",
    color_hex: "#6B6B6B",
    tone: "dark-dramatic",
    description: "A sophisticated grey Italian marble with white veining. Modern and versatile.",
    main_image_url: "https://images.unsplash.com/photo-1586609143615-019f8824129f?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1586609143615-019f8824129f?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed", "Brushed", "Sandblasted"],
    applications: ["Countertop", "Wall", "Floor", "Bathroom"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_rosso_levanto",
    name: "Rosso Levanto",
    stone_type: "Marble",
    color: "Red",
    color_hex: "#8B2500",
    tone: "warm-earth",
    description: "A dramatic deep red Italian marble with green and white veining. Bold and luxurious.",
    main_image_url: "https://images.unsplash.com/photo-1625288114652-12e2b3d11549?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1625288114652-12e2b3d11549?w=1200&q=80"
    ],
    finishes: ["Polished", "Honed"],
    applications: ["Wall", "Floor"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: false
  },
  {
    id: "mat_botticino",
    name: "Botticino",
    stone_type: "Marble",
    color: "Beige",
    color_hex: "#D9C9A5",
    tone: "light-neutral",
    description: "A warm beige Italian marble with subtle veining. Classic and timeless elegance.",
    main_image_url: "https://images.pexels.com/photos/4709524/pexels-photo-4709524.jpeg?auto=compress&cs=tinysrgb&w=800",
    images: [
      "https://images.pexels.com/photos/4709524/pexels-photo-4709524.jpeg?auto=compress&cs=tinysrgb&w=1200"
    ],
    finishes: ["Polished", "Honed", "Brushed", "Tumbled"],
    applications: ["Countertop", "Wall", "Floor", "Bathroom"],
    origin: "Italy",
    producer: "Margraf",
    is_featured: true
  },
  {
    id: "mat_violet_damasco",
    name: "Violet Damasco",
    stone_type: "Marble",
    color: "Purple",
    color_hex: "#5D3A6C",
    tone: "blue-deep",
    description: "A rare purple marble with dramatic veining. Unique and unforgettable.",
    main_image_url: "https://images.unsplash.com/photo-1742870668961-b3a1721ab483?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1742870668961-b3a1721ab483?w=1200&q=80"
    ],
    finishes: ["Polished"],
    applications: ["Wall"],
    origin: "Turkey",
    producer: "Margraf",
    is_featured: false
  }
];

// Color palette for navigation
export const COLORS = [
  { name: "White", hex: "#FFFFFF", count: 45 },
  { name: "Black", hex: "#1A1A1A", count: 12 },
  { name: "Grey", hex: "#808080", count: 28 },
  { name: "Beige", hex: "#D9C9A5", count: 38 },
  { name: "Brown", hex: "#6B4423", count: 22 },
  { name: "Green", hex: "#2D5A4E", count: 8 },
  { name: "Blue", hex: "#1E3A5F", count: 5 },
  { name: "Pink", hex: "#D4A5A5", count: 6 },
  { name: "Red", hex: "#8B2500", count: 4 },
  { name: "Yellow", hex: "#D4A017", count: 7 },
  { name: "Purple", hex: "#5D3A6C", count: 3 }
];

// Stone types
export const STONE_TYPES = [
  { name: "Marble", count: 156 },
  { name: "Granite", count: 45 },
  { name: "Quartzite", count: 38 },
  { name: "Onyx", count: 12 },
  { name: "Travertine", count: 18 },
  { name: "Limestone", count: 13 }
];

// Finishes
export const FINISHES = [
  "Polished",
  "Honed",
  "Brushed",
  "Bush-Hammered",
  "Sanded",
  "Sandblasted",
  "Tumbled",
  "Flamed"
];

/**
 * ATMOSPHERE CATEGORIES
 * ======================
 * Used for the "Explore by Atmosphere" page.
 * Each atmosphere links to filtered materials by tone/mood.
 */
export const ATMOSPHERES = [
  {
    id: 'light-neutral',
    name: 'Light & Neutral',
    nameIt: 'Chiaro e Neutro',
    description: 'Timeless elegance. Soft whites and subtle greys.',
    descriptionIt: 'Eleganza senza tempo. Bianchi morbidi e grigi sottili.',
    mood: 'Serenity • Purity • Space',
    moodIt: 'Serenità • Purezza • Spazio',
    // White marble texture - Carrara style
    image: 'https://images.unsplash.com/photo-1694378061101-bf38a2fcc596?w=1200&q=80',
    colors: ['White', 'Grey', 'Beige'],
    featured_material: 'Bianco Carrara',
    count: 45
  },
  {
    id: 'dark-dramatic',
    name: 'Dark & Dramatic',
    nameIt: 'Scuro e Drammatico',
    description: 'Bold statements. Deep blacks and rich contrasts.',
    descriptionIt: 'Affermazioni audaci. Neri profondi e ricchi contrasti.',
    mood: 'Power • Sophistication • Mystery',
    moodIt: 'Potenza • Raffinatezza • Mistero',
    // Black marble with veining
    image: 'https://images.pexels.com/photos/11285487/pexels-photo-11285487.png?auto=compress&cs=tinysrgb&w=1200',
    colors: ['Black', 'Grey'],
    featured_material: 'Nero Marquina',
    count: 28
  },
  {
    id: 'warm-earth',
    name: 'Warm Earth',
    nameIt: 'Calore della Terra',
    description: 'Natural warmth. Golden beiges and rich browns.',
    descriptionIt: 'Calore naturale. Beige dorati e marroni ricchi.',
    mood: 'Comfort • Warmth • Grounding',
    moodIt: 'Comfort • Calore • Radicamento',
    // Travertine/warm beige marble texture
    image: 'https://images.pexels.com/photos/4709524/pexels-photo-4709524.jpeg?auto=compress&cs=tinysrgb&w=1200',
    colors: ['Beige', 'Brown', 'Yellow'],
    featured_material: 'Botticino',
    count: 38
  },
  {
    id: 'green-organic',
    name: 'Green & Organic',
    nameIt: 'Verde e Organico',
    description: "Nature's palette. Forest greens and mineral tones.",
    descriptionIt: 'La tavolozza della natura. Verdi forestali e toni minerali.',
    mood: 'Balance • Nature • Renewal',
    moodIt: 'Equilibrio • Natura • Rinnovamento',
    // Green marble texture - Verde Alpi style
    image: 'https://images.unsplash.com/photo-1653939614751-aab4b19b10fd?w=1200&q=80',
    colors: ['Green'],
    featured_material: 'Verde Alpi',
    count: 12
  },
  {
    id: 'blue-deep',
    name: 'Blue & Deep',
    nameIt: 'Blu e Profondo',
    description: 'Ocean depths. Rare blues and crystalline surfaces.',
    descriptionIt: 'Profondità oceaniche. Blu rari e superfici cristalline.',
    mood: 'Calm • Depth • Rarity',
    moodIt: 'Calma • Profondità • Rarità',
    // Blue granite/stone texture
    image: 'https://images.unsplash.com/photo-1760784213120-04b0f83317a9?w=1200&q=80',
    colors: ['Blue', 'Purple'],
    featured_material: 'Azul Bahia',
    count: 8
  },
  {
    id: 'textured-veined',
    name: 'Textured & Veined',
    nameIt: 'Texture e Venature',
    description: 'Movement and drama. Bold veining patterns.',
    descriptionIt: 'Movimento e dramma. Venature audaci.',
    mood: 'Expression • Uniqueness • Art',
    moodIt: 'Espressione • Unicità • Arte',
    // Dramatic veined marble with gold tones
    image: 'https://images.unsplash.com/photo-1690049089775-b915262c89d0?w=1200&q=80',
    colors: ['White', 'Grey', 'Black'],
    featured_material: 'Calacatta Oro',
    count: 32
  }
];

/**
 * Get materials filtered by atmosphere/tone
 */
export const getMaterialsByTone = (toneId) => {
  const atmosphere = ATMOSPHERES.find(a => a.id === toneId);
  if (!atmosphere) return MOCK_MATERIALS;
  
  return MOCK_MATERIALS.filter(m => 
    m.tone === toneId || atmosphere.colors.includes(m.color)
  );
};
